import { NgModule } from '@angular/core';
import { HisTranslationSharedModule } from './his-translation-shared.module';


@NgModule( {
    imports: [
        HisTranslationSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisTranslationSharedModule
    ]
} )

export class HisTranslationCoreModule {
}
